import { NavLink } from "react-router-dom";
import './style.scss';

const Header = () => {
    return (
        <nav className="custom-navbar navbar navbar-expand-lg navbar-dark">
            <div className="container">
                <NavLink className="navbar-brand" to="/">
                    <img src="./logo-transparent.svg" className="image" alt="Logo"/>
                    <span className="name">CryptoGood</span>
                </NavLink>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                    <ul className="navbar-nav gap-3">
                        <NavLink className="nav-link" to="/">
                            Home
                        </NavLink>
                        <NavLink className="nav-link" to="/contact">
                            Contact
                        </NavLink>
                        <NavLink className="nav-link" to="/privacy">
                            Privacy
                        </NavLink>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;
